var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26696 16.5186H6.77219C6.12107 16.5186 5.59323 17.0421 5.59323 17.6879C5.59323 18.3337 6.12107 18.8572 6.77219 18.8572H14.2833L16.8536 17.8957V9.85956H15.5584L12.1926 5.99744L11.8995 4.39592C11.8575 4.16666 11.6563 4 11.4213 4H10.846C10.0114 4 9.33481 4.6711 9.33481 5.49893C9.33481 6.12301 9.45789 6.74104 9.69713 7.31824L10.5628 9.50252H10.3412M8.30142 11.8412H5.682C5.03091 11.8412 4.50304 11.3177 4.50304 10.6719C4.50304 10.0261 5.03091 9.50255 5.682 9.50255H10.3412M7.67373 11.8412H5.17895C4.5278 11.8412 4 12.3648 4 13.0105C4 13.6563 4.5278 14.1799 5.17895 14.1799H7.67373M8.38106 14.1799H5.88629C5.23514 14.1799 4.70734 14.7034 4.70734 15.3492C4.70734 15.995 5.23514 16.5186 5.88629 16.5186H8.38106M16.8536 19H20V8.91674H16.8536V19Z",
    stroke: "#CF2F92",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.8a2c8efb0fe3c1548316e6ad97b416f7.svg";
export { ForwardRef as ReactComponent };